import { render, staticRenderFns } from "./expertise-specialisee.vue?vue&type=template&id=7fbbb254"
import script from "./expertise-specialisee.vue?vue&type=script&lang=ts"
export * from "./expertise-specialisee.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports